module.exports = __webpack_public_path__ + "static/media/S4N10-5.40d6952a.svg";